<div class="flex flex-col flex-auto min-w-0">

  <!-- Main -->
  <div class="flex-auto p-6 sm:p-10">
    <app-files-list filesRoute="/v1/files"></app-files-list>
  </div>

</div>